module.exports = __webpack_public_path__ + "registration-53018bea/energizer-8a21a7d8e3ec609336fc8b362b4119b2.jpeg";